<template>
    <div class="thumbnailSlider__inner--mobileSlider" v-if="mobile">
        <ThumbnailSliderMobile
            ref="mobileSliderRef"
            :sliderData="slotMobileSlider"
            :current="current">
        </ThumbnailSliderMobile>
    </div>
    <div class="thumbnailSlider__inner--sliderWrapper" v-else>
        <ThumbnailSliderMain
            ref="mainSliderRef"
            :sliderData="slotStageSlider"
            :thumbData="slotTabSlider"
            :current="current">
        </ThumbnailSliderMain>
    </div>
</template>

<script>
import {computed, ref, useSlots} from "vue";
import {windowOrientation} from "@/utils";
import ThumbnailSliderMain from "@/components/ThumbnailSlider/ThumbnailSliderMain.vue";
import ThumbnailSliderMobile from "@/components/ThumbnailSlider/ThumbnailSliderMobile.vue";

export default {
    name: "thumb-nail-slider",
    components: {
        ThumbnailSliderMain,
        ThumbnailSliderMobile
    },
    setup() {
        //Slots
        const slotStageSlider = useSlots().default();
        const slotTabSlider = useSlots().tabslider();
        const slotMobileSlider = useSlots().mobileslider();

        //Refs
        const current = ref(0);
        const mobileSliderRef = ref();
        const mainSliderRef = ref();

        //Windows Functions
        const mobile = computed(() => {
            return windowOrientation.value.width < 768;
        });
        const tablet = computed(() => {
            return windowOrientation.value.width < 1024;
        });
        const desktop = computed(() => {
            return windowOrientation.value.width > 1540;
        });

        return {
            slotStageSlider,
            slotTabSlider,
            slotMobileSlider,
            mobile,
            tablet,
            desktop,
            current,
            mobileSliderRef,
            mainSliderRef
        };
    },
    methods: {}
};
</script>

<style lang="scss">
@use "@/scss/design-library/placeholders";
@use "@/scss/design-library/grid";
@use "@/scss/design-library/colors";
@use "@/scss/design-library/functions/calculate";
@use "@/scss/design-library/typography";
@use "@/scss/design-library/variables";

.thumbnailSlider {
    position: relative;
    @include grid.inner();

    .text__inner {
        @include grid.cell-span_(12);
        @include grid.media-query_up_(desktop) {
            grid-column-start: 2;
            grid-column-end: 12;
        }
    }

    .teaser-image {
        position: relative;
        z-index: 1;
    }

    .teaser-wrapper {
        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            display: block;
            width: 100%;
            height: 100%;
            background: #{variables.$default-text-gradient};
            opacity: 1;
        }
    }
    .teaser-content {
        position: relative;
        z-index: 3;
    }
;

    .teaser-description {
        margin-bottom: #{calculate.rem(16)};
    }

    .thumbnailSlider__inner--mobileSlider,
    .thumbnailSlider__inner--sliderWrapper {
        position: relative;
        @include grid.cell-span_(12);
    }

    .thumbnailSlider__inner--sliderWrapper {
        .thumbnailSlider__inner--stageSlider,
        .thumbnailSlider__inner--thumbnailSlider {
            @extend %teaser;
            z-index: 100;

            .swiper-wrapper {
                transition: all 1s;
                margin-left: 8vw;
                @include grid.media-query_up_(tablet_portrait) {
                    margin-left: 0;
                }

                &.is-end {
                    margin-left: -8vw;
                    @include grid.media-query_up_(tablet_portrait) {
                        margin-left: 0;
                    }
                }

                .swiper-slide {
                    height: auto;
                }

                .teaser-wrapper {
                    width: 100%;
                    height: 100%;
                    min-height: calculate.rem(360);
                    align-items: center;

                    @include grid.media-query_up_(tablet_portrait) {
                        min-height: calculate.rem(458);
                        align-items: stretch;
                        justify-content: space-between;

                        .teaser-image::before,
                        .teaser-image::after {
                            opacity: 0.3;
                            backdrop-filter: blur(20px)
                        }
                        &:hover {
                            .teaser-image::before,
                            .teaser-image::after {
                                opacity: 0.4;
                            }
                        }
                    }

                    .teaser-content {
                        position: relative;
                        z-index: 3;
                        * {
                            &:visited,
                            &:focus {
                                text-decoration: none;
                            }
                        }

                        padding-left: #{calculate.rem(16)};

                        @include grid.media-query_up_(tablet_portrait) {
                            padding-left: #{calculate.rem(53)};
                            padding-top: #{calculate.rem(57)};
                            padding-bottom: #{calculate.rem(50)};
                        }

                        @include grid.media-query_up_(tablet_landscape) {
                            padding-left: #{calculate.rem(72)};
                            padding-top: #{calculate.rem(59)};
                        }

                        @include grid.media-query_up_(desktop) {
                            padding-left: #{calculate.rem(105)};
                            padding-top: #{calculate.rem(40)};
                        }
                    }

                    .overline {
                        @include typography.subtitle1;
                        margin-block-end: #{calculate.rem(4)};
                    }

                    .h1 {
                        margin-bottom: 10px;
                    }

                    .body-text,
                    .body-text p {
                        font-size: calculate.rem(20);
                        line-height: calculate.rem(26);
                    }

                    .body-text {
                        display: none;
                        @include grid.media-query_up_(tablet_portrait) {
                            display: block;
                        }
                    }

                    .teaser-text-overlay {
                        @include typography.body-text();
                        display: none;
                        background: rgba(#F7F7F799, 0.6);
                        padding: #{calculate.rem(30)} #{calculate.rem(25)};
                        backdrop-filter: blur(5px);
                        color: #{colors.$anthrazit};
                        z-index: 10;
                        width: 30%;

                        .headline {
                            @include typography.headline3();
                        }

                        @include grid.media-query_up_(tablet_landscape) {
                            display: block;
                            width: 40%;
                        }
                    }
                }
            }

            .button-wrapper {
                position: absolute;
                display: flex;
                justify-content: space-between;
                align-items: center;
                top: 0;
                left: 0;
                right: 0;
                height: 100%;
                padding: inherit;

                .swiper-navigation {
                    cursor: pointer;

                    &.swiper-prev {
                        margin-left: -40px
                    }

                    &.swiper-next {
                        margin-right: -40px
                    }
                }
            }
        }
    }

    .thumbnailSlider__inner--stageSlider {
        margin-bottom: 20px;
    }

    .thumbnailSlider__inner--mobileSlider {
        @extend %teaser;

        .teaser-element {
            position: relative;
            display: block;

            .teaser-wrapper {
                align-items: center;
                margin-bottom: #{calculate.rem(15)};
                height: #{calculate.rem(350)};

                .teaser-image::before,
                .teaser-image::after {
                    opacity: 0.2;
                }
                &:hover {
                    .teaser-image::before,
                    .teaser-image::after {
                        opacity: 0.3;
                    }
                }

                .teaser-content .body-text {
                    display: none;
                }
            }
        }
    }

    .thumbnailSlider__inner--thumbnailTabs {
        &-wrapper {
            justify-content: left;
            display: flex;

            .c_1,
            .c_2,
            .c_3,
            .c_4,
            .c_5,
            .c_6 {
                justify-content: center;

                .thumbnailSlider__inner--thumbnailTabs-inner {
                    width: 100%;
                    justify-content: center;
                }
            }

            .scrollbar {
                display: block;
                width: 100%;

                .scrollbarWrapper {
                    display: flex;
                    padding-bottom: #{calculate.rem(20)};

                    .thumbnailSlider__inner--thumbnailTabs-inner {
                        width: auto;
                        justify-content: left;

                        .thumbnail {
                            display: block;
                            width: #{calculate.rem(230)};
                        }
                    }
                }
            }
        }

        &-inner {
            display: flex;
            width: 100%;

            > div {
                //width: #{calculate.rem(230)};
                margin-right: #{calculate.rem(20)};
                flex: 1 1 auto;
                max-width: calculate.rem(464);

                &:last-child {
                    margin-right: unset;
                }
            }
        }
    }

    .thumbnail.active,
    .swiper-slide-thumb-active {
        .thumbnail-content {
            opacity: 0;
        }

        .thumbnail-image {
            transform: scale(1.1);
        }
    }

    .thumbnail-wrapper {
        position: relative;
        height: #{calculate.rem(110)};
        cursor: pointer;
        overflow: hidden;
        border-radius: #{calculate.rem(16)};

        .thumbnail-image {
            z-index: 1;
            position: absolute;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: #{calculate.rem(16)};
            transition: transform 100ms linear;

            img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }

        .thumbnail-content {
            position: relative;
            z-index: 10;
            background: rgba(255, 255, 255, 0.8);
            text-align: center;
            height: 100%;
            width: 100%;
            transition: opacity 100ms linear;

            &__inner {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #{colors.$anthrazit};
            }
        }

        &:hover {
            .thumbnail-content {
                transition: opacity 200ms linear;
                opacity: 0;
            }

            .thumbnail-image {
                transform: scale(1.1);
                transition: transform 400ms ease-in-out;
            }
        }
    }
}

</style>
